"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCourtPointByName = exports.COURTPOINTS = exports.CourtLineLabel = exports.CourtPointLabel = void 0;
exports.CourtPointLabel = {
    base_b_dl: "Baseline Doubles Left (Trainer Side)",
    base_b_l: "Baseline Singles Left (Trainer Side)",
    base_b_m: "Baseline Center (Trainer Side)",
    base_b_r: "Base Singles Right (Trainer Side)",
    base_b_dr: "Baseline Doubles Right (Trainer Side)",
    base_t_dl: "Baseline Doubles Left (Player Side)",
    base_t_l: "Baseline Singles Left (Player Side)",
    base_t_m: "Center Baseline",
    base_t_r: "Baseline Singles Right (Player Side)",
    base_t_dr: "Baseline Doubles Right (Player Side)",
    serve_b_dl: "Service Line Doubles Left (Trainer Side)",
    serve_b_l: "Service Line Singles Left (Trainer Side)",
    serve_b_m: "Service Line Center (Trainer Side)",
    serve_b_r: "Service Line Singles Right (Trainer Side)",
    serve_b_dr: "Service Line Doubles Right (Trainer Side)",
    serve_t_dl: "Service Line Doubles Left (Player Side)",
    serve_t_l: "Service Line Singles Left (Player Side)",
    serve_t_m: "Center Service Line",
    serve_t_r: "Service Line Singles Right (Player Side)",
    serve_t_dr: "Service Line Doubles Right (Player Side)",
    net_l: "Net Bottom Singles Left",
    net_dl: "Net Bottom Doubles Left",
    net_m: "Net Bottom Middle",
    net_dr: "Net Bottom Doubles Right",
    net_r: "Net Bottom Singles Right",
    play_t_l: "Play Area Left (Player Side)",
    play_t_m: "Play Area Center (Player Side)",
    play_t_r: "Play Area Right (Player Side)",
    play_b_l: "Play Area Left (Trainer Side)",
    play_b_m: "Play Area Center (Trainer Side)",
    play_b_r: "Play Area Right (Trainer Side)",
    netpost_l_b: "Net Post Bottom Left",
    netpost_l_t: "Net Post Top Left",
    netpost_r_b: "Net Post Bottom Right",
    netpost_r_t: "Net Post Top Right",
};
exports.CourtLineLabel = {
    base_b_dl: "Baseline (Trainer Side)",
    base_b_l: "Baseline (Trainer Side)",
    base_b_m: "Baseline (Trainer Side)",
    base_b_r: "Baseline (Trainer Side)",
    base_b_dr: "Baseline (Trainer Side)",
    base_t_dl: "Baseline (Player Side)",
    base_t_l: "Baseline (Player Side)",
    base_t_m: "Center Baseline (Player Side)",
    base_t_r: "Baseline (Player Side)",
    base_t_dr: "Baseline (Player Side)",
    serve_b_dl: "Service Line (Trainer Side)",
    serve_b_l: "Service Line (Trainer Side)",
    serve_b_m: "Service Line (Trainer Side)",
    serve_b_r: "Service Line (Trainer Side)",
    serve_b_dr: "Service Line (Trainer Side)",
    serve_t_dl: "Service Line (Player Side)",
    serve_t_l: "Service Line (Player Side)",
    serve_t_m: "Service Line (Player Side)",
    serve_t_r: "Service Line (Player Side)",
    serve_t_dr: "Service Line (Player Side)",
    net_l: "Net Bottom",
    net_dl: "Net Bottom",
    net_m: "Net Bottom",
    net_dr: "Net Bottom",
    net_r: "Net Bottom",
    play_t_l: "Play Area (Player Side)",
    play_t_m: "Play Area (Player Side)",
    play_t_r: "Play Area (Player Side)",
    play_b_l: "Play Area (Trainer Side)",
    play_b_m: "Play Area (Trainer Side)",
    play_b_r: "Play Area (Trainer Side)",
    netpost_l_b: "Net Post Bottom",
    netpost_l_t: "Net Post Top",
    netpost_r_b: "Net Post Bottom",
    netpost_r_t: "Net Post Top",
};
exports.COURTPOINTS = {
    PLATFORM_TENNIS: {
        base_t_l: { x: -3.048, y: 6.7056, z: 0.0 },
        base_t_dl: { x: -2.4384, y: 6.7056, z: 0.0 },
        base_t_m: { x: 0.0, y: 6.7056, z: 0.0 },
        base_t_dr: { x: 2.4384, y: 6.7056, z: 0.0 },
        base_t_r: { x: 3.048, y: 6.7056, z: 0.0 },
        base_b_l: { x: -3.048, y: -6.7056, z: 0.0 },
        base_b_dl: { x: -2.4384, y: -6.7056, z: 0.0 },
        base_b_m: { x: 0.0, y: -6.7056, z: 0.0 },
        base_b_dr: { x: 2.4384, y: -6.7056, z: 0.0 },
        base_b_r: { x: 3.048, y: -6.7056, z: 0.0 },
        serve_t_l: { x: -3.048, y: 3.6576, z: 0.0 },
        serve_t_dl: { x: -2.4384, y: 3.6576, z: 0.0 },
        serve_t_m: { x: 0.0, y: 3.6576, z: 0.0 },
        serve_t_dr: { x: 2.4384, y: 3.6576, z: 0.0 },
        serve_t_r: { x: 3.048, y: 3.6576, z: 0.0 },
        serve_b_l: { x: -3.048, y: -3.6576, z: 0.0 },
        serve_b_dl: { x: -2.4384, y: -3.6576, z: 0.0 },
        serve_b_m: { x: 0.0, y: -3.6576, z: 0.0 },
        serve_b_dr: { x: 2.4384, y: -3.6576, z: 0.0 },
        serve_b_r: { x: 3.048, y: -3.6576, z: 0.0 },
        net_l: { x: -3.048, y: 0.0, z: 0.0 },
        net_dl: { x: -2.4384, y: 0.0, z: 0.0 },
        net_m: { x: 0.0, y: 0.0, z: 0.0 },
        net_dr: { x: 2.4384, y: 0.0, z: 0.0 },
        net_r: { x: 3.048, y: 0.0, z: 0.0 },
        play_t_l: { x: -4.572, y: 9.144, z: 0.0 },
        play_t_m: { x: 0, y: 9.144, z: 0.0 },
        play_t_r: { x: 4.572, y: 9.144, z: 0.0 },
        play_b_l: { x: -4.572, y: -9.144, z: 0.0 },
        play_b_m: { x: 0, y: -9.144, z: 0.0 },
        play_b_r: { x: 4.572, y: -9.144, z: 0.0 },
        netpost_l_b: { x: -3.5052, y: 0.0, z: 0.0 },
        netpost_l_t: { x: -3.5052, y: 0.0, z: 0.9398 },
        netpost_r_b: { x: 3.5052, y: 0.0, z: 0.0 },
        netpost_r_t: { x: 3.5052, y: 0.0, z: 0.9398 },
    },
    PADEL: {
        base_t_l: { x: -5.0, y: 10.0, z: 0.0 },
        base_t_m: { x: 0.0, y: 10.0, z: 0.0 },
        base_t_r: { x: 5.0, y: 10.0, z: 0.0 },
        base_b_l: { x: -5.0, y: -10.0, z: 0.0 },
        base_b_m: { x: 0.0, y: -10.0, z: 0.0 },
        base_b_r: { x: 5.0, y: -10.0, z: 0.0 },
        serve_t_l: { x: -5.0, y: 7.0, z: 0.0 },
        serve_t_m: { x: 0.0, y: 7.0, z: 0.0 },
        serve_t_r: { x: 5.0, y: 7.0, z: 0.0 },
        serve_b_l: { x: -5.0, y: -7.0, z: 0.0 },
        serve_b_m: { x: 0.0, y: -7.0, z: 0.0 },
        serve_b_r: { x: 5.0, y: -7.0, z: 0.0 },
        net_l: { x: -5.0, y: 0.0, z: 0.0 },
        net_m: { x: 0.0, y: 0.0, z: 0.0 },
        net_r: { x: 5.0, y: 0.0, z: 0.0 },
        play_t_l: { x: -6.5, y: 11.5, z: 0.0 },
        play_t_m: { x: 0, y: 11.5, z: 0.0 },
        play_t_r: { x: 6.5, y: 11.5, z: 0.0 },
        play_b_l: { x: -6.5, y: -11.5, z: 0.0 },
        play_b_m: { x: 0, y: -11.5, z: 0.0 },
        play_b_r: { x: 6.5, y: -11.5, z: 0.0 },
        netpost_l_b: { x: -5.0365, y: 0.0, z: 0.0 },
        netpost_l_t: { x: -5.0365, y: 0.0, z: 0.92 },
        netpost_r_b: { x: 5.0365, y: 0.0, z: 0.0 },
        netpost_r_t: { x: 5.0365, y: 0.0, z: 0.92 },
    },
    TENNIS: {
        base_t_l: { x: -5.485, y: 11.885, z: 0.0 },
        base_t_dl: { x: -4.115, y: 11.885, z: 0.0 },
        base_t_m: { x: 0.0, y: 11.885, z: 0.0 },
        base_t_dr: { x: 4.115, y: 11.885, z: 0.0 },
        base_t_r: { x: 5.485, y: 11.885, z: 0.0 },
        base_b_l: { x: -5.485, y: -11.885, z: 0.0 },
        base_b_dl: { x: -4.115, y: -11.885, z: 0.0 },
        base_b_m: { x: 0.0, y: -11.885, z: 0.0 },
        base_b_dr: { x: 4.115, y: -11.885, z: 0.0 },
        base_b_r: { x: 5.485, y: -11.885, z: 0.0 },
        serve_t_l: { x: -5.485, y: 6.4, z: 0.0 },
        serve_t_dl: { x: -4.115, y: 6.4, z: 0.0 },
        serve_t_m: { x: 0.0, y: 6.4, z: 0.0 },
        serve_t_dr: { x: 4.115, y: 6.4, z: 0.0 },
        serve_t_r: { x: 5.485, y: 6.4, z: 0.0 },
        serve_b_l: { x: -5.485, y: -6.4, z: 0.0 },
        serve_b_dl: { x: -4.115, y: -6.4, z: 0.0 },
        serve_b_m: { x: 0.0, y: -6.4, z: 0.0 },
        serve_b_dr: { x: 4.115, y: -6.4, z: 0.0 },
        serve_b_r: { x: 5.485, y: -6.4, z: 0.0 },
        net_l: { x: -5.485, y: 0.0, z: 0.0 },
        net_dl: { x: -4.115, y: 0.0, z: 0.0 },
        net_m: { x: 0.0, y: 0.0, z: 0.0 },
        net_dr: { x: 4.115, y: 0.0, z: 0.0 },
        net_r: { x: 5.485, y: 0.0, z: 0.0 },
        play_t_l: { x: -9.144, y: 18.288, z: 0.0 },
        play_t_m: { x: 0, y: 18.288, z: 0.0 },
        play_t_r: { x: 9.144, y: 18.288, z: 0.0 },
        play_b_l: { x: -9.144, y: -18.288, z: 0.0 },
        play_b_m: { x: 0, y: -18.288, z: 0.0 },
        play_b_r: { x: 9.144, y: -18.288, z: 0.0 },
        netpost_l_b: { x: -6.399, y: 0.0, z: 0.0 },
        netpost_l_t: { x: -6.399, y: 0.0, z: 1.07 },
        netpost_r_b: { x: 6.399, y: 0.0, z: 0.0 },
        netpost_r_t: { x: 6.399, y: 0.0, z: 1.07 },
    },
    PICKLEBALL: {
        base_t_l: { x: -3.048, y: 6.7056, z: 0.0 },
        base_t_m: { x: 0.0, y: 6.7056, z: 0.0 },
        base_t_r: { x: 3.048, y: 6.7056, z: 0.0 },
        base_b_l: { x: -3.048, y: -6.7056, z: 0.0 },
        base_b_m: { x: 0.0, y: -6.7056, z: 0.0 },
        base_b_r: { x: 3.048, y: -6.7056, z: 0.0 },
        serve_t_l: { x: -3.048, y: 2.1336, z: 0.0 },
        serve_t_m: { x: 0.0, y: 2.1336, z: 0.0 },
        serve_t_r: { x: 3.048, y: 2.1336, z: 0.0 },
        serve_b_l: { x: -3.048, y: -2.1336, z: 0.0 },
        serve_b_m: { x: 0.0, y: -2.1336, z: 0.0 },
        serve_b_r: { x: 3.048, y: -2.1336, z: 0.0 },
        net_l: { x: -3.048, y: 0.0, z: 0.0 },
        net_m: { x: 0.0, y: 0.0, z: 0.0 },
        net_r: { x: 3.048, y: 0.0, z: 0.0 },
        play_t_l: { x: -4.572, y: 9.144, z: 0.0 },
        play_t_m: { x: 0.0, y: 9.144, z: 0.0 },
        play_t_r: { x: 4.572, y: 9.144, z: 0.0 },
        play_b_l: { x: -4.572, y: -9.144, z: 0.0 },
        play_b_m: { x: 0.0, y: -9.144, z: 0.0 },
        play_b_r: { x: 4.572, y: -9.144, z: 0.0 },
        netpost_l_b: { x: -3.3528, y: 0.0, z: 0.0 },
        netpost_l_t: { x: -3.3528, y: 0.0, z: 0.9144 },
        netpost_r_b: { x: 3.3528, y: 0.0, z: 0.0 },
        netpost_r_t: { x: 3.3528, y: 0.0, z: 0.9144 },
    },
    // Placeholder: Lacrosse has no field markings of its own yet, so it
    // reuses the tennis court points - the wall-less court whose art the
    // visualizer currently stands in with. See LacrosseCourtPointName.
    LACROSSE: {
        base_t_l: { x: -5.485, y: 11.885, z: 0.0 },
        base_t_dl: { x: -4.115, y: 11.885, z: 0.0 },
        base_t_m: { x: 0.0, y: 11.885, z: 0.0 },
        base_t_dr: { x: 4.115, y: 11.885, z: 0.0 },
        base_t_r: { x: 5.485, y: 11.885, z: 0.0 },
        base_b_l: { x: -5.485, y: -11.885, z: 0.0 },
        base_b_dl: { x: -4.115, y: -11.885, z: 0.0 },
        base_b_m: { x: 0.0, y: -11.885, z: 0.0 },
        base_b_dr: { x: 4.115, y: -11.885, z: 0.0 },
        base_b_r: { x: 5.485, y: -11.885, z: 0.0 },
        serve_t_l: { x: -5.485, y: 6.4, z: 0.0 },
        serve_t_dl: { x: -4.115, y: 6.4, z: 0.0 },
        serve_t_m: { x: 0.0, y: 6.4, z: 0.0 },
        serve_t_dr: { x: 4.115, y: 6.4, z: 0.0 },
        serve_t_r: { x: 5.485, y: 6.4, z: 0.0 },
        serve_b_l: { x: -5.485, y: -6.4, z: 0.0 },
        serve_b_dl: { x: -4.115, y: -6.4, z: 0.0 },
        serve_b_m: { x: 0.0, y: -6.4, z: 0.0 },
        serve_b_dr: { x: 4.115, y: -6.4, z: 0.0 },
        serve_b_r: { x: 5.485, y: -6.4, z: 0.0 },
        net_l: { x: -5.485, y: 0.0, z: 0.0 },
        net_dl: { x: -4.115, y: 0.0, z: 0.0 },
        net_m: { x: 0.0, y: 0.0, z: 0.0 },
        net_dr: { x: 4.115, y: 0.0, z: 0.0 },
        net_r: { x: 5.485, y: 0.0, z: 0.0 },
        play_t_l: { x: -9.144, y: 18.288, z: 0.0 },
        play_t_m: { x: 0, y: 18.288, z: 0.0 },
        play_t_r: { x: 9.144, y: 18.288, z: 0.0 },
        play_b_l: { x: -9.144, y: -18.288, z: 0.0 },
        play_b_m: { x: 0, y: -18.288, z: 0.0 },
        play_b_r: { x: 9.144, y: -18.288, z: 0.0 },
        netpost_l_b: { x: -6.399, y: 0.0, z: 0.0 },
        netpost_l_t: { x: -6.399, y: 0.0, z: 1.07 },
        netpost_r_b: { x: 6.399, y: 0.0, z: 0.0 },
        netpost_r_t: { x: 6.399, y: 0.0, z: 1.07 },
    },
};
function getCourtPointByName(sport, pointName) {
    const sportPoints = exports.COURTPOINTS[sport];
    if (pointName in sportPoints) {
        return sportPoints[pointName];
    }
    return null;
}
exports.getCourtPointByName = getCourtPointByName;
